import {domains} from '../constants/Utils';
import {
    ADMINISTRATION_ASE_ANSWERING_SCHEMA_PATH,
    ADMINISTRATION_ASE_ESCALATION_SCHEMA_PATH,
    ADMINISTRATION_ASE_SOLUTION_GROUP_PATH
} from './paths';

export const getAdminSGPath = (domain) => {
    if(!domain) {
        throw new Error('No domain');
    }

    if (domain === domains.ASE) {
        return ADMINISTRATION_ASE_SOLUTION_GROUP_PATH;
    } else {
        throw new Error('Invalid domain: ' + domain);
    }
}

export const getAdminEscalationSchemaPath = (domain) => {
    if(!domain) {
        throw new Error('No domain');
    }
    if (domain === domains.ASE) {
        return ADMINISTRATION_ASE_ESCALATION_SCHEMA_PATH;
    } else {
        throw new Error('Invalid domain: ' + domain);
    }
}

export const getAdminAnsweringSchemaPath = (domain) => {
    if(!domain) {
        throw new Error('No domain');
    }
    if (domain === domains.ASE) {
        return ADMINISTRATION_ASE_ANSWERING_SCHEMA_PATH;
    } else {
        throw new Error('Invalid domain: ' + domain);
    }
}
